const GAP = 6;
const ABOVE_GAP = 8;
const MARGIN = 8;

export function placeCapacityPopover({ place, anchor, column, bounds, viewport, width, height }) {
  let left = anchor.left;
  if (column) left = column.left;
  else if (place === "below") left = anchor.right - width;
  left = Math.max(bounds.left, Math.min(left, bounds.right - width));

  const gap = place === "above" ? ABOVE_GAP : GAP;
  const below = anchor.bottom + gap;
  const above = anchor.top - gap - height;
  const fitsBelow = below + height + MARGIN <= viewport.bottom;
  const fitsAbove = above >= viewport.top + MARGIN;
  const prefersAbove = place === "above";
  const side = prefersAbove ? (fitsAbove || !fitsBelow ? "above" : "below") : fitsBelow || !fitsAbove ? "below" : "above";

  return { left, top: side === "above" ? above : below, side };
}
